export const ALL_MESSAGES_REQUEST = "ALL_MESSAGES_REQUEST";
export const ALL_MESSAGES_SUCCESS = "ALL_MESSAGES_SUCCESS";
export const ALL_MESSAGES_FAIL = "ALL_MESSAGES_FAIL";
export const ALL_MESSAGES_ADD = "ALL_MESSAGES_ADD";
export const ALL_MESSAGES_UPDATE = "ALL_MESSAGES_UPDATE";
export const ALL_MESSAGES_DELETE = "ALL_MESSAGES_DELETE";

export const NEW_MESSAGE_REQUEST = "NEW_MESSAGE_REQUEST";
export const NEW_MESSAGE_SUCCESS = "NEW_MESSAGE_SUCCESS";
export const NEW_MESSAGE_RESET = "NEW_MESSAGE_RESET";
export const NEW_MESSAGE_FAIL = "NEW_MESSAGE_FAIL";

export const SHARE_POST_REQUEST = "SHARE_POST_REQUEST";
export const SHARE_POST_SUCCESS = "SHARE_POST_SUCCESS";
export const SHARE_POST_FAIL = "SHARE_POST_FAIL";
export const SHARE_POST_RESET = "SHARE_POST_RESET";

export const EDIT_MESSAGE_REQUEST = "EDIT_MESSAGE_REQUEST";
export const EDIT_MESSAGE_SUCCESS = "EDIT_MESSAGE_SUCCESS";
export const EDIT_MESSAGE_FAIL = "EDIT_MESSAGE_FAIL";
export const EDIT_MESSAGE_RESET = "EDIT_MESSAGE_RESET";

export const DELETE_MESSAGE_REQUEST = "DELETE_MESSAGE_REQUEST";
export const DELETE_MESSAGE_SUCCESS = "DELETE_MESSAGE_SUCCESS";
export const DELETE_MESSAGE_FAIL = "DELETE_MESSAGE_FAIL";
export const DELETE_MESSAGE_RESET = "DELETE_MESSAGE_RESET";

export const SEARCH_MESSAGES_REQUEST = "SEARCH_MESSAGES_REQUEST";
export const SEARCH_MESSAGES_SUCCESS = "SEARCH_MESSAGES_SUCCESS";
export const SEARCH_MESSAGES_FAIL = "SEARCH_MESSAGES_FAIL";
export const SEARCH_MESSAGES_RESET = "SEARCH_MESSAGES_RESET";

export const REACT_MESSAGE_REQUEST = "REACT_MESSAGE_REQUEST";
export const REACT_MESSAGE_SUCCESS = "REACT_MESSAGE_SUCCESS";
export const REACT_MESSAGE_FAIL = "REACT_MESSAGE_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";